<template>
  <CFooter class="preika-footer">
    <div class="preika-footer__inner">
      <div class="preika-footer__support">
        <CIcon name="cil-speech"/>
        <span>
          システムに関するお問い合わせ・要望は
          <CLink
            href="https://app.slack.com/client/T0BR4U4RL/C05A7FVGV0E"
            target="_blank"
            rel="noopener noreferrer"
          >
            #preika_bug_report
          </CLink>
          へお寄せください。
        </span>
      </div>

      <div class="preika-footer__copyright">
        <span>{{ productName }}</span>
        <span>·</span>
        <span>&copy; AKI Inc. All Rights Reserved.</span>
      </div>
    </div>
  </CFooter>
</template>

<script>
import { PRODUCT_NAME } from '@/common/productName'

export default {
  name: 'TheFooter',

  computed: {
    /** 売るときの正式な表記。**1か所から取る。** */
    productName () {
      return PRODUCT_NAME
    }
  }
}
</script>
